export default {
      id: "rim-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#rim",
      toString: function () {
        return this.url;
      }
    }